import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import { Alert } from "@mui/material";

import { questionTypes } from "../../Editor/itemTypesAddButton";

export default function HistoryDialog(props) {
  const { t } = useTranslation();
  const { onClose, table, open, labels } = props;
  const columns = [
    { field: "label", headerName: t("timeline.buttons.label"), width: 140 },
    {
      field: "question",
      headerName: t("timeline.buttons.question"),
      width: 400,
    },
    {
      field: "type",
      headerName: "Type",
      width: 75,
      renderCell: ({ value }) =>
        questionTypes[value] ? (
          <Tooltip title={t(`editor.questionTypes.${value}.title`)}>
            <div style={{ alignItems: "center", display: "flex" }}>
              {questionTypes[value]?.icon}
            </div>
          </Tooltip>
        ) : (
          value
        ),
    },
  ];
  const [selection, setSelection] = useState(labels);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setSelection(labels);
  }, [labels]);

  const handleCancel = () => {
    onClose(labels);
  };

  const handleOk = () => {
    if (selection.length > 0) {
      onClose(selection);
    } else {
      setShowError(true);
    }
  };

  const handleSelection = (selectionModel) => {
    setSelection(selectionModel);
  };

  return (
    <Dialog
      maxWidth="md"
      aria-labelledby="history-dialog-title"
      open={open}
      onClose={handleCancel}
    >
      <React.Fragment>
        <DialogTitle>
          {t("timeline.labelDialogTitle", {
            count: `${selection.length}/${table.length}`,
          })}
        </DialogTitle>
        <DialogContent>
          <div style={{ height: 400, width: 700 }}>
            <DataGrid
              rows={table}
              columns={columns.map((column) => ({
                ...column,
                sortable: false,
              }))} // disable sorting
              //pageSize={table.length}
              checkboxSelection
              selectionModel={selection}
              onSelectionModelChange={handleSelection}
              hideFooter
              disableColumnMenu
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} color="inherit">
            {t("common.actions.cancel")}
          </Button>
          <Button onClick={handleOk} color="primary">
            {t("common.actions.ok")}
          </Button>
        </DialogActions>
        {showError ? (
          <Alert severity="error">{t("timeline.errorNoLabelsSelected")}</Alert>
        ) : null}
      </React.Fragment>
    </Dialog>
  );
}

HistoryDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  table: PropTypes.array.isRequired,
};
